import { data } from '../../svg/ExpandContent/data';
import { makeIcon } from '../makeIcon';

export const ExpandContent = makeIcon(data, 'expand_content', 'ExpandContent');

export default ExpandContent;
